

const ComingsoonPage = () => {
    return (
            <div className="notfoundpage">
                <div className="pageContent pt-5  h-100">
                    <div className="container-fluid px-0 h-100">
                        <div className="d-flex flex-column justify-content-between h-100">
                            <div className='text-center py-5'>
                                <img src={require('../../assets/images/404Logo.png')} alt='logo' className='img-fluid' />
                            </div>
                            <div className='text-center mt-auto'>
                                    <div className='cmsontxt'>Coming Soon</div>
                            </div>
                            <div className='cmsoon'>
                                <div className='centershadow'></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

    )
}

export default ComingsoonPage;